import StarAiIcon from '@assets/images/icons/star.svg?react'
import type { ID } from '@octopus-do/octopus-project-core'
import { TinyPopover, Tooltip } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import { useGeneratePages } from './hooks'
import css from './styles.module.css'

const WIDTH = 216

const stopPropagation = (e: React.SyntheticEvent) => {
  e.stopPropagation()
}

interface ContentProps {
  initial: string
}

const Content: React.FC<ContentProps> = ({ initial }) => (
  <TinyPopover.PromptInput
    initial={initial}
    placeholder="Please specify page names..."
    submitLabel="Generate"
    variant="purple"
  />
)

const Trigger = forwardRef<HTMLButtonElement>((_, ref) => {
  const { active, toggle } = TinyPopover.useTrigger()

  return (
    <Tooltip label="Generate pages">
      <button
        className={clsJoin(
          css.star,
          'node-button-children',
          active && css.active
        )}
        onClick={toggle}
        ref={ref}
        type="button"
      >
        <StarAiIcon />
      </button>
    </Tooltip>
  )
})

interface Props {
  nodeId: ID
}

// The star under a page: the same prompt popover as Generate blocks in the
// page toolbar, anchored to the star. Events from the portaled popover bubble
// through React to the node, so the anchor swallows them like ToolbarAnchor.
export const GeneratePagesPopover: React.FC<Props> = ({ nodeId }) => {
  const { initial, onGenerate } = useGeneratePages(nodeId)

  return (
    <div
      className={css.anchor}
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
      onMouseUp={stopPropagation}
    >
      <TinyPopover.Root
        content={Content}
        initial={initial}
        onSubmit={onGenerate}
        width={WIDTH}
      >
        <Trigger />
      </TinyPopover.Root>
    </div>
  )
}
